import React, { useReducer, useEffect } from "react";
import { Permissions } from "../Component/Permissions/PermissionsInterface.";
import { getFXReportDefaultPermissions } from '../Component/Reusables/Utility';

export interface State {
  email: string,
  user_id: string,
  permissions: Permissions;
}

export interface Action {
  type: "SET_PERMISSION" | "UPDATE_PERMISSION" | "RESET_STATE";
  payload?: Partial<State>; // Make payload optional
}

export const initialState: State = {
  email: "rajesh.r@congruentindia.com",
  user_id: "123456789-123456789-123456789",
  permissions: {
    profileSettings: {
      isGeneralSettingsVisible: true,
      isGeneralSettingSaveBtnVisible: false,
      isExchangeRateVisible: true,
      isExchangeRateSaveBtnVisible: false,
      isPauseTransactionVisible: false,
      isCardVerification: false,
    },
    dashboard: {
      isVisible: false,
      isHeaderVisible: false,
      isTransactionMetricsVisible: false,
      isFinancialMetricsVisible: false,
      isRiskMetricsVisible: false,
      isSupportMetricsVisible: false,
      isPerformanceMetricsVisible: false,
    },
    transactionLogs: {
      isVisible: false,
      isDownloadVisible: false,
      isFraudMarkVisible: false,
      isRefundVisible: false,
    },
    userLogs: {
      isVisible: false,
    },
    complianceLogs: {
      isVisible: false,
      isZendeskNavigationAllowed: false,
      isTransactionNavigationAllowed: false,
    },
    userDetails: {
      isVisible: false,
      isVisibleAdminsTab: false,
      isVisibleMobileUsersTab: false,
      isVisibleSupportStaffsTab: false,
      isBlockUserVisible: false,
      isUserSettingsVisible: false,
      isUserSettingSaveBtnVisible: false,
      isStatusHistoryVisible: false,
      isWalletHistoryTabVisible: false,
      isUpdatePermissionVisible: false,
      isDownloadVisibleAdmins: false,
      isDownloadVisibleMobileUsers: false,
      isDownloadVisibleSupportStaffs: false,
      isEditUserInfoVisible: false,
      isAddUserVisible: false
    },
    userTransactionReport: {
      isVisible: false,
      isDownloadVisible: false,
      isLimitHistoryVisible: false,
      isLimitHistoryDownloadVisible: false,
    },
    promoCode: {
      isVisible: true,
      isDownloadVisiblePromoCode: true,
      isDownloadVisibleCashbackCoupon: true,
      isVisiblePromoCodeTab: true,
      isVisibleCouponCodeTab: true,
      isAddPromoCodeVisible: true,
      isAddCouponCodeVisible: true,
      isBlockCodeVisible: true,
      isActiveCodeVisible: true
    },
    exchangeRates: {
      isVisible: false,
      isDownloadVisible: false,
      isAddCurrencyPairVisible: false,
      isEditRatesVisible: false,
      isEditPaymentMethodVisible: false,
      isActiveCurrencyAllowed: false,
      isInactiveCurrencyAllowed: false,
    },
    referrals: {
      isVisible: false,
      isDownloadVisible: false,
      isReferralSettingsVisible: false,
      isSaveSettingsAllowed: false,
      isViewRefereesVisible: false,
      isTransactionNavigationAllowed: false
    },
    chargeBack: {
      isVisible: true,
      isDownloadFileAllowed: true,
      isSendEmailAllowd: true
    },
    partner: {
      isVisible: true,
      isVisibleLiquidityTab: true,
      isVisiblePayoutTab: true,
      isDownloadVisibleLiquidity: true,
      isDownloadVisiblePayout: true,
      isAddVisibleLiquidity: true,
      isAddVisiblePayout: true,
      isEditPartnersVisible: true,
      isActivePartnersVisible: true,
      isInActivePartnersVisible: true,
    },
    ratereconciliation: {
      isVisible: true,
    },
    fxReports: getFXReportDefaultPermissions(),
    fxAllocation: {
      isVisible: true,
      isCreatePurchaseVisible: true,
      isCreateLiquidityVisible: true,
      isCreatePartnerVisible: true
    },
  },
};

const batchInfo = localStorage.getItem("batch-info");
const localState: State = batchInfo ? JSON.parse(batchInfo) : initialState;

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "SET_PERMISSION":
      return { ...state, ...action.payload };

    case "UPDATE_PERMISSION":
      return {
        ...state,
        permissions: {
          ...state.permissions,
          ...action.payload?.permissions,
        },
      };

    case "RESET_STATE":
      return initialState;

    default:
      return state;
  }
};


export interface SyncContextType {
  state: State;
  dispatch: React.Dispatch<Action>;
}

const SyncContext = React.createContext<SyncContextType | undefined>(undefined);

function SyncProvider({ children }: { children: React.ReactNode }) {
  const [state, dispatch] = useReducer(reducer, localState);

  useEffect(() => {
    localStorage.setItem("batch-info", JSON.stringify(state));
  }, [state]);

  return (
    <SyncContext.Provider value={{ state, dispatch }}>
      {children}
    </SyncContext.Provider>
  );
}

export { SyncContext, SyncProvider };
